<template>
  <customModal
    :containerxl="true"
    :bodyxl="true"
    :footerShow="true"
    @closeModal="closeModal"
  >
    <!-- Header -->
    <template #title>
      <i class="fa fa-code"></i>{{ $t("navigations.view program") }} 
    </template>

    <template #body>
      <!-- Loading state -->
      <div class="center-state" v-if="loading">
        <img src="../../assets/img/loading.gif" width="15" alt="Loading" />
        <p class="mt-2">{{ $t("navigations.please wait data is loading") }}</p>
      </div>

      <!-- No Data state -->
      <div v-else-if="!program" class="center-state">
        <i class="fa fa-exclamation-circle fa-2x text-muted"></i>
        <p class="mt-2 text-muted">{{ $t("navigations.no program available") }}</p>
      </div>

      <!-- Content -->
      <div v-else class="ids-modal-body">
        <!-- Info Strip -->
          <div class="info-card-title">
          <i class="fa fa-info-circle"></i> {{ $t("navigations.program info") }}
          </div>
        <div class="info-card">
           <div class="d-flex justify-content-between pb-2">
            <span>
              <i class="fa fa-television" style="color:#145faf"></i>
              <strong class="ms-2">{{ program.programTitle }}</strong>
            </span>
            <span :class="['badge-status', program.statusBadgeClass]">
              <i class="fa fa-circle" style="font-size:8px"></i>
              {{ program.status }}
            </span>
            </div>
          <div class="info-row ">
            <span >
              <i class="fa fa-file-code-o ms-1" style="color:#145faf; font-size: 12px;"></i>
              <strong class="ms-2">{{ program.programFile }}</strong>
            </span>
            <span class="sep">|</span>
            <span>
              <i class="fa fa-bar-chart" style="color:#145faf"></i>
              {{$t("navigations.report type")}}: <strong>{{ program.reportType }}</strong>
            </span>
            <span class="sep">|</span>
            <span>
              <i class="fa fa-code-fork"></i>
              {{$t("navigations.version")}}: <strong>{{ program.version }}</strong>
            </span>
            <span class="sep">|</span>
            <span>
              <i class="fa fa-user-circle-o" style="color:#145faf"></i>
              {{$t("navigations.author")}}: <strong>{{ program.author }}</strong>
            </span>
            <!-- <span class="sep">|</span> -->
            <!-- <span :class="['badge-status', program.statusBadgeClass]">
              <i class="fa fa-circle" style="font-size:8px"></i>
              {{ program.status }}
            </span> -->
          </div>
        </div>

        <!-- Tabs -->
        <div class="log-tabs">
          <button
            id="tab-details"
            :class="['log-tab', activeTab === 'details' ? 'log-tab-active' : '']"
            @click="activeTab = 'details'"
          >
            <i class="fa fa-list-alt"></i>{{ $t("navigations.program details") }}
          </button>
          <button
            id="tab-rprogram"
            :class="['log-tab', activeTab === 'rprogram' ? 'log-tab-active' : '']"
            @click="activeTab = 'rprogram'"
          >
            <i class="fa fa-code"></i>{{ $t("navigations.r program") }}
            <span class="tab-badge-ai">{{ $t("navigations.auto-generated") }}</span>
          </button>
          <button
            id="tab-trace"
            :class="['log-tab', activeTab === 'trace' ? 'log-tab-active' : '']"
            @click="activeTab = 'trace'"
          >
            <i class="fa fa-sitemap"></i>{{ $t("navigations.traceability")}}
            <span class="tab-badge">{{ program.traceability.runCount }} runs</span>
          </button>
        </div>

        <!-- ════ TAB: Program Details ════ -->
        <div v-show="activeTab === 'details'" class="tab-content">
          <div class="details-grid">

            <!-- Program Configuration -->
            <div class="detail-section">
              <div class="detail-section-title">
                <i class="fa fa-file-text-o"></i>{{ $t("navigations.program configuration") }}
              </div>
              <div
                v-for="(value, label) in program.programConfig"
                :key="label"
                class="detail-row"
              >
                <span class="detail-label">{{ label }}</span>
                <span class="detail-value">{{ value }}</span>
              </div>
            </div>

            <!-- Data & Filters -->
            <div class="detail-section">
              <div class="detail-section-title text-success">
                <i class="fa fa-filter"></i> {{ $t("navigations.data&filters") }}
              </div>
              <div
                v-for="(value, label) in program.dataFilters"
                :key="label"
                class="detail-row"
              >
                <span class="detail-label">{{ label }}</span>
                <span class="detail-value">{{ value }}</span>
              </div>
            </div>

            <!-- Assignment -->
            <div class="detail-section">
              <div class="detail-section-title text-warning">
                <i class="fa fa-users"></i>{{ $t("navigations.assignment") }}
              </div>
              <div
                v-for="(value, label) in program.assignment"
                :key="label"
                class="detail-row"
              >
                <span class="detail-label">{{ label }}</span>
                <span class="detail-value">
                  <template v-if="typeof value === 'object' && value !== null">
                    <span :class="['badge-status', value.badgeClass]">{{ value.label }}</span>
                  </template>
                  <template v-else>{{ value }}</template>
                </span>
              </div>
            </div>

            <!-- Row Filters -->
            <div class="detail-section">
              <div class="detail-section-title text-secondary">
                <i class="fa fa-table"></i>{{ $t("navigations.row filters") }}
              </div>
              <div
                v-for="(value, label) in program.rowFilters"
                :key="label"
                class="detail-row"
              >
                <span class="detail-label">{{ label }}</span>
                <span class="detail-value">{{ value }}</span>
              </div>
            </div>

          </div>
        </div>

        <!-- ════ TAB: R Program ════ -->
        <div v-show="activeTab === 'rprogram'" class="tab-content">

          <div class="code-toolbar">
            <div class="code-toolbar-left">
              <i class="fa fa-file-code-o" style="color:#7c3aed"></i>
              <strong>{{ program.rProgram.fileName }}</strong>
              <span style="color:#3d4470">|</span>
              <span>{{ program.rProgram.version }}</span>
              <span style="color:#3d4470">|</span>
              <span class="tab-badge-ai" style="font-size:10px;padding:2px 7px;">
                {{ program.rProgram.generatedBy }}
              </span>
            </div>
            <div class="code-toolbar-right">
              <button class="code-btn" @click="copyCode">
                <i :class="copied ? 'fa fa-check' : 'fa fa-copy'"></i>
                {{ copied ? 'Copied' : 'Copy' }}
              </button>
              <button class="code-btn" @click="downloadCode">
                <i class="fa fa-download"></i>{{ $t("navigations.downloadr") }}
              </button>
            </div>
          </div>

          <div class="code-terminal" ref="codeBlock">
            <div
              v-for="(line, idx) in program.rProgram.codeLines"
              :key="idx"
            >
              <span class="ln">{{ idx + 1 }}</span>
              <template v-if="line.tokens.length === 0">&nbsp;</template>
              <span
                v-for="(token, ti) in line.tokens"
                :key="ti"
                :class="token.cls"
              >{{ token.text }}</span>
            </div>
          </div>

        </div>

        <!-- ════ TAB: Traceability ════ -->
        <div v-show="activeTab === 'trace'" class="tab-content">
          <div class="trace-scroll">

            <div style="font-size:11px;font-weight:700;color:#145faf;text-transform:uppercase;letter-spacing:.5px;margin-bottom:10px;display:flex;align-items:center;gap:6px;">
              <i class="fa fa-link"></i>{{ $t("navigations.fulltraceabilitychain") }}
            </div>

            <div class="trace-chain">

              <!-- Node 1: TocProgrammeMapItem -->
              <div class="trace-node">
                <div class="trace-node-line">
                  <div class="trace-dot"></div>
                  <div class="trace-vline"></div>
                </div>
                <div class="trace-card">
                  <div class="trace-card-header">
                    <div class="trace-card-title">
                      <i class="fa fa-database"></i>{{ $t("navigations.tocprogrammemapitem") }}
                    </div>
                    <span class="trace-card-badge badge-status badge-dev">{{$t("navigations.source")}}</span>
                  </div>
                  <div class="trace-card-row">
                    <span class="trace-card-key">{{$t("navigations.tocmapid")}}</span>
                    <span class="trace-card-val hash">{{ program.traceability.source._id }}</span>
                  </div>
                  <div class="trace-card-row">
                    <span class="trace-card-key">{{$t("navigations.tocid")}}</span>
                    <span class="trace-card-val">{{ program.traceability.source.TocId }}</span>
                  </div>
                  <div class="trace-card-row">
                    <span class="trace-card-key">{{$t("navigations.studyref")}}</span>
                    <span class="trace-card-val">{{ program.traceability.source.Study }}</span>
                  </div>
                  <div class="trace-card-row">
                    <span class="trace-card-key">{{$t("navigations.reportid")}}</span>
                    <span class="trace-card-val">{{ program.traceability.source.ReportId }}</span>
                  </div>
                  <div class="trace-card-row">
                    <span class="trace-card-key">{{$t("navigations.programname")}}</span>
                    <span class="trace-card-val">{{ program.traceability.source.ProgramName }}</span>
                  </div>
                </div>
              </div>

              <!-- Node 2: ProgramRegistry -->
              <div class="trace-node">
                <div class="trace-node-line">
                  <div class="trace-dot trace-dot-purple"></div>
                  <div class="trace-vline"></div>
                </div>
                <div class="trace-card">
                  <div class="trace-card-header">
                    <div class="trace-card-title" style="color:#7c3aed">
                      <i class="fa fa-archive"></i>{{ $t("navigations.programregistry") }}
                    </div>
                    <span class="trace-card-badge badge-status badge-ai">{{ $t("navigations.auto-generated") }}</span>
                  </div>
                  <div class="trace-card-row">
                    <span class="trace-card-key">{{ $t("navigations.registryId") }}</span>
                    <span class="trace-card-val hash">{{ program.traceability.registry.registryId }}</span>
                  </div>
                  <div class="trace-card-row">
                    <span class="trace-card-key">{{ $t("navigations.scriptFile") }}</span>
                    <span class="trace-card-val">{{ program.traceability.registry.scriptFile }}</span>
                  </div>
                  <div class="trace-card-row">
                    <span class="trace-card-key">{{ $t("navigations.scriptPath") }}</span>
                    <span class="trace-card-val">{{ program.traceability.registry.scriptPath }}</span>
                  </div>
                  <div class="trace-card-row">
                    <span class="trace-card-key">{{ $t("navigations.contentHash") }}</span>
                    <span class="trace-card-val hash">{{ program.traceability.registry.contentHash }}</span>
                  </div>
                  <div class="trace-card-row">
                    <span class="trace-card-key">{{ $t("navigations.registeredBy") }}</span>
                    <span class="trace-card-val">{{ program.traceability.registry.registeredBy }}</span>
                  </div>
                  <div class="trace-card-row">
                    <span class="trace-card-key">{{ $t("navigations.registeredAt") }}</span>
                    <span class="trace-card-val">{{ program.traceability.registry.registeredAt }}</span>
                  </div>
                  <div class="trace-card-row">
                    <span class="trace-card-key">{{ $t("navigations.status") }}</span>
                    <span class="trace-card-val">
                      <span :class="['badge-status', program.traceability.registry.status.badgeClass]">
                        {{ program.traceability.registry.status.label }}
                      </span>
                    </span>
                  </div>
                </div>
              </div>

              <!-- Node 3: Azure Blob -->
              <div class="trace-node">
                <div class="trace-node-line mb-4">
                  <div class="trace-dot trace-dot-teal"></div>
                </div>
                <div class="trace-card">
                  <div class="trace-card-header">
                    <div class="trace-card-title" style="color:#0f766e">
                      <i class="fa fa-cloud"></i>{{ $t("navigations.azure blob storage") }}
                    </div>
                    <span class="trace-card-badge badge-status badge-upload">{{ $t("navigations.stored") }}</span>
                  </div>
                  <div class="trace-card-row">
                    <span class="trace-card-key">{{ $t("navigations.container") }}</span>
                    <span class="trace-card-val">{{ program.traceability.blobStorage.container }}</span>
                  </div>
                  <div class="trace-card-row">
                    <span class="trace-card-key">{{ $t("navigations.file") }}</span>
                    <span class="trace-card-val">{{ program.traceability.blobStorage.file }}</span>
                  </div>
                  <div class="trace-card-row">
                    <span class="trace-card-key">{{ $t("navigations.commit id") }}</span>
                    <span class="trace-card-val">{{ program.traceability.blobStorage.CommitIDDisplay }}</span>
                  </div>
                   <div class="trace-card-row">
                    <span class="trace-card-key">{{ $t("navigations.core branch") }}</span>
                    <span class="trace-card-val">{{ program.traceability.blobStorage.CoreBranchDisplay }}</span>
                  </div>
                   <div class="trace-card-row">
                    <span class="trace-card-key">{{ $t("navigations.working branch") }}</span>
                    <span class="trace-card-val">{{ program.traceability.blobStorage.BranchDisplay }}</span>
                  </div>
                  <div class="trace-card-row">
                    <span class="trace-card-key">{{ $t("navigations.local backup") }}Local backup</span>
                    <span class="trace-card-val">{{ program.traceability.blobStorage.localBackup }}</span>
                  </div>
                </div>
              </div>

              <!-- Node 4: Execution Log -->
              <!-- <div class="trace-node">
                <div class="trace-node-line">
                  <div class="trace-dot trace-dot-success"></div>
                </div>
                <div class="trace-card">
                  <div class="trace-card-header">
                    <div class="trace-card-title" style="color:#1a7a3a">
                      <i class="fa fa-history"></i> Execution Log
                    </div>
                    <span class="trace-card-badge badge-status badge-success">
                      {{ program.traceability.runCount }} runs
                    </span>
                  </div>
                  <table class="trace-exec-table">
                    <thead>
                      <tr>
                        <th>Run ID</th>
                        <th>Run At</th>
                        <th>Run By</th>
                        <th>Status</th>
                        <th>Content Hash</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="run in program.traceability.executionLog"
                        :key="run.runId"
                      >
                        <td style="font-family:'Courier New',monospace;font-size:10px;">{{ run.runId }}</td>
                        <td>{{ run.runAt }}</td>
                        <td>{{ run.runBy }}</td>
                        <td>
                          <span :class="['badge-status', run.statusBadgeClass]" style="font-size:10px;">
                            {{ run.status }}
                          </span>
                        </td>
                        <td style="font-family:'Courier New',monospace;font-size:10px;color:#0f766e;">
                          {{ run.contentHash }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div> -->

            </div><!-- /trace-chain -->
          </div><!-- /trace-scroll -->
        </div>
      </div>
    </template>
  </customModal>
</template>

<script src="./ViewProgramModal.js"></script>

<style scoped>


* { box-sizing: border-box; margin: 0; padding: 0; }

/* ── Info card ── */
.info-card { border: 1px solid #dde4ef; border-radius: 5px; padding: 10px 14px; background: #f5f8ff; margin-bottom: 12px; flex-shrink: 0; }
.info-card-title { font-size: 11px; font-weight: 700; color: #145faf; margin-bottom: 8px; display: flex; align-items: center; gap: 5px; }
.info-row { display: flex; flex-wrap: nowrap; align-items: center; gap: 5px 15px; font-size: 11px; color: #333; overflow-x: auto; }
.info-row span { display: flex; align-items: center; gap: 4px; white-space: nowrap; flex-shrink: 0; }
.info-row strong { color: #111; }
.sep { color: #ccc; }

/* ── Tabs ── */
.log-tabs { display: flex; border-bottom: 2px solid #e0e0e0; gap: 0; flex-shrink: 0; margin-bottom: 12px; }
.log-tab {
  background: none; border: none; border-bottom: 2px solid transparent; margin-bottom: -2px;
  padding: 7px 18px; font-size: 12px; font-weight: 600; color: #666; cursor: pointer;
  display: flex; align-items: center; gap: 6px;
}
.log-tab:hover { color: #145faf; }
.log-tab-active { border-bottom: 2px solid #145faf; color: #145faf; }
.tab-badge          { background: #145faf; color: #fff; border-radius: 10px; padding: 1px 6px; font-size: 10px; }
.tab-badge-ai       { background: #7c3aed; color: #fff; border-radius: 10px; padding: 1px 6px; font-size: 10px; }
.tab-badge-upload   { background: #0f766e; color: #fff; border-radius: 10px; padding: 1px 6px; font-size: 10px; }

/* ── Center State ── */
.center-state {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  height: 100%;
  min-height: 450px;
}

/* ── Tab content area ── */
.tab-content { flex: 1; overflow: hidden; display: flex; flex-direction: column; }

/* ═══ TAB 1 — Program Details ═══ */
.details-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; overflow-y: auto; padding-right: 4px; }
.detail-section { background: #f9fafb; border: 1px solid #e5e9f0; border-radius: 5px; padding: 10px 12px; }
.detail-section-title { font-size: 11px; font-weight: 700; color: #145faf; text-transform: uppercase; letter-spacing: .5px; margin-bottom: 5px; display: flex; align-items: center; gap: 6px; }
.detail-row { display: flex; justify-content: space-between; align-items: flex-start; padding: 1px 0; border-bottom: 1px solid #eef0f5; font-size: 12px; }
.detail-row:last-child { border-bottom: none; }
.detail-label { color: #777; min-width: 130px; flex-shrink: 0; }
.detail-value { color: #111; font-weight: 600; text-align: right; word-break: break-all; }

/* ═══ TAB 2 — R Program ═══ */
.code-toolbar { display: flex; align-items: center; justify-content: space-between; background: #1e1e2e; border-radius: 5px 5px 0 0; padding: 7px 12px; flex-shrink: 0; }
.code-toolbar-left  { display: flex; align-items: center; gap: 10px; font-size: 12px; color: #a0a8c0; }
.code-toolbar-left strong { color: #e2e8f0; }
.code-toolbar-right { display: flex; gap: 6px; }
.code-btn { background: #2d3250; border: 1px solid #3d4470; color: #a0a8c0; border-radius: 4px; padding: 3px 10px; font-size: 11px; cursor: pointer; display: flex; align-items: center; gap: 4px; }
.code-btn:hover { background: #3d4470; color: #e2e8f0; }
.code-terminal { background: #0d1117; border-radius: 0 0 5px 5px; padding: 12px 16px; overflow-y: auto; flex: 1; font-family: 'Courier New', monospace; font-size: 12px; line-height: 1.7; color: #e6edf3; }
.ln { color: #3d4470; user-select: none; display: inline-block; min-width: 30px; margin-right: 12px; text-align: right; }
.code-comment { color: #8b949e; }
.code-keyword { color: #ff7b72; }
.code-string  { color: #a5d6ff; }
.code-func    { color: #d2a8ff; }
.code-number  { color: #79c0ff; }
.code-section { color: #ffa657; }
.code-plain   { color: #e6edf3; }
.code-hash    { color: #f0883e; font-weight: 600; }

/* ═══ TAB 3 — Traceability ═══ */
.trace-scroll { overflow-y: auto; flex: 1; padding-right: 4px; }
.trace-chain  { display: flex; flex-direction: column; gap: 0; margin-bottom: 16px; }
.trace-node   { display: flex; align-items: stretch; gap: 0; }
.trace-node-line { display: flex; flex-direction: column; align-items: center; width: 32px; flex-shrink: 0; }
.trace-dot         { width: 14px; height: 14px; border-radius: 50%; background: #145faf; border: 2px solid #fff; box-shadow: 0 0 0 2px #145faf; flex-shrink: 0; margin-top: 14px; }
.trace-dot-success { background: #1a7a3a; box-shadow: 0 0 0 2px #1a7a3a; }
.trace-dot-purple  { background: #7c3aed; box-shadow: 0 0 0 2px #7c3aed; }
.trace-dot-teal    { background: #0f766e; box-shadow: 0 0 0 2px #0f766e; }
.trace-vline { width: 2px; background: #e0e8f0; flex: 1; margin: 2px auto; }
.trace-card  { flex: 1; margin: 6px 0 6px 8px; border: 1px solid #e0e8f0; border-radius: 6px; padding: 10px 14px; background: #f9fafb; }
.trace-card-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 6px; }
.trace-card-title  { font-size: 12px; font-weight: 700; color: #145faf; display: flex; align-items: center; gap: 6px; }
.trace-card-badge  { font-size: 10px; padding: 2px 8px; border-radius: 8px; }
.trace-card-row    { display: flex; gap: 6px; font-size: 11px; margin-bottom: 3px; align-items: flex-start; }
.trace-card-key    { color: #888; min-width: 120px; flex-shrink: 0; }
.trace-card-val    { color: #111; font-weight: 600; word-break: break-all; font-family: 'Courier New', monospace; font-size: 11px; }
.trace-card-val.hash { color: #0f766e; }
.trace-exec-table  { width: 100%; border-collapse: collapse; font-size: 12px; margin-top: 8px; }
.trace-exec-table th { background: #eef2f9; color: #145faf; font-size: 11px; font-weight: 700; padding: 5px 10px; text-align: left; border-bottom: 2px solid #d0daea; }
.trace-exec-table td { padding: 5px 10px; border-bottom: 1px solid #f0f0f0; color: #333; }
.trace-exec-table tr:hover td { background: #f5f8ff; }

/* ── Badges ── */
.badge-status  { border-radius: 10px; padding: 2px 9px; font-size: 10px; font-weight: 700; }
.badge-dev     { background: #fff3cd; color: #856404; border: 1px solid #ffc107; }
.badge-success { background: #d4f0dc; color: #1a7a3a; border: 1px solid #a3d9b1; }
.badge-ai      { background: #ede9fe; color: #5b21b6; border: 1px solid #c4b5fd; }
.badge-upload  { background: #d1fae5; color: #065f46; border: 1px solid #6ee7b7; }

/* ── Custom Modal body-xl Height Overrides ── */
.ids-modal-body {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* ── Buttons ── */
.btn         { padding: 5px 16px; border-radius: 4px; font-size: 12px; font-weight: 600; cursor: pointer; border: none; display: flex; align-items: center; gap: 6px; }
.btn-outline { background: #fff; border: 1px solid #ddd; color: #555; }
.btn-primary { background: linear-gradient(135deg, #145faf, #04223b); color: #fff; }
.btn-outline:hover { background: #f5f5f5; }
.btn-primary:hover { opacity: .9; }

</style>

<style>
/* Non-scoped styles for webkit scrollbar pseudo-elements to prevent Vue compiler data-attribute scoping bugs */
.ids-modal-body::-webkit-scrollbar,
.code-terminal::-webkit-scrollbar,
.details-grid::-webkit-scrollbar,
.trace-scroll::-webkit-scrollbar,
.iframe-body::-webkit-scrollbar {
  width: 4px !important;
  height: 4px !important;
}
.ids-modal-body::-webkit-scrollbar-track,
.code-terminal::-webkit-scrollbar-track,
.details-grid::-webkit-scrollbar-track,
.trace-scroll::-webkit-scrollbar-track,
.iframe-body::-webkit-scrollbar-track {
  background: transparent !important;
}
.ids-modal-body::-webkit-scrollbar-thumb,
.code-terminal::-webkit-scrollbar-thumb,
.details-grid::-webkit-scrollbar-thumb,
.trace-scroll::-webkit-scrollbar-thumb,
.iframe-body::-webkit-scrollbar-thumb {
  background: #9ca3af !important;
  border-radius: 10px !important;
}
.ids-modal-body::-webkit-scrollbar-thumb:hover,
.code-terminal::-webkit-scrollbar-thumb:hover,
.details-grid::-webkit-scrollbar-thumb:hover,
.trace-scroll::-webkit-scrollbar-thumb:hover,
.iframe-body::-webkit-scrollbar-thumb:hover {
  background: #6b7280 !important;
}
</style>